import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { getProductEnrichmentStatus } from '../services/catalog-operations.service';

/** Fetches enriched/not-enriched flags for the current page of products in one
 *  batch call. Disabled until both the job id and a non-empty product id list are
 *  available. Returns a Map<productId, enriched> — `undefined` for an id the
 *  response didn't report, so callers can distinguish "unknown" from "not enriched". */
export function useProductEnrichmentStatus(
  enrichmentJobId: string | undefined,
  productIds: string[],
) {
  return useQuery({
    queryKey: queryKeys.catalogOperations.productEnrichmentStatus(
      enrichmentJobId ?? '',
      productIds,
    ),
    queryFn: () => getProductEnrichmentStatus(enrichmentJobId ?? '', productIds),
    enabled: Boolean(enrichmentJobId) && productIds.length > 0,
    staleTime: 5 * 60 * 1_000,
  });
}
